import type { DialogOfUi, TOptions } from '@/components/base'

/** 全局唯一弹框,命令式调用,如果要多个实例请使用组件注册 */
// @ts-ignore
let dialogRef: InstanceType<typeof DialogOfUi> | null = null
// @ts-ignore
export const setDialogOfUiRef = (instance: InstanceType<typeof DialogOfUi>) => {
  dialogRef = instance
}

export const openDialogOfUi = (options: TOptions) => {
  dialogRef && dialogRef.handleOpen(options)
}
export const closeDialogOfUi = () => {
  dialogRef && dialogRef.handleClose()
}
